import stuartPic from "@/public/images/artists/stuart.png";
import { Artist } from "@/types/types";

export const stuart = {
  id: "273",
  name: "Stuart",
  image: stuartPic,
  description: `Stuart's voice is big, gritty, and unmistakably soulful, built to take up space.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fstuart-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Unprocessed", "Funk", "Disco", "Rock", "Soul", "Belting"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 51,
        high: 69,
      },
      sweetSpot: 63,
    },
  },
} as const satisfies Artist;
